<template>
	<checkout-block>
		<checkout-block-header>MobilePay Checkout</checkout-block-header>
		<checkout-block-body>
			<form @submit.prevent="validateMobilePay()" class="flex -mx-2">
					<label class="px-2 flex flex-col w-3/4">
							<div class="pb-2 font-bold">Angiv dit mobilnummer</div>
							<div>
							<input type="tel" inputmode="numeric" v-model="mobilePayData.Mobile" placeholder="Indtast dit mobilnummer (8 cifre)" class="input-text w-full" @keyup="changeMobile" @change="changeMobile"  />
							</div>
            	<div v-if="showValidationMessage" class="text-red-700 font-normal text-micro sm:text-xs">Dit mobilnummer skal bestå af 8 cifre</div>
					</label>

					<div class="w-1/3 pt-8">
							<button type="submit" class=" border-gray-400 border rounded-sm text-base inline-flex items-center py-2 px-4 bg-transparent">
								<spinner v-if="loading"></spinner>
								<span v-else>Bekræft</span>
							</button>
					</div>
			</form>

			<div v-if="mobilePayData.ConfirmedNumber && mobilePayData.ConfirmedNumber != '' && mobilePayData.ConfirmedNumber == mobilePayData.Mobile">

				<div class="flex -ml-2 mt-6 flex-wrap" v-if="mobilePayData.ParticipantId == '00000000-0000-0000-0000-000000000000'">
						<participant-field class="md:w-1/2" label="Køn" type="select-string" v-model="mobilePayData.Gender" :values="[{Key: 'Mand', Value: 'Mand'}, {Key: 'Kvinde', Value: 'Kvinde'}, {Key: 'Andet', Value: 'Andet'}]" :required="true" :show-required-message="isMissing('Gender')" @blur="validate('Gender')" @keyup="[saveParticipantData(), validate('Gender', true)]" @change="validate('Gender', true)" />
						<participant-field class="mt-6 md:mt-0 md:w-1/2" label="Fødselsdato" placeholder="dd/mm/åååå" type="date" v-model="mobilePayData.DateOfBirth" :required="true" :show-required-message="isMissing('DateOfBirth')" @blur="validate('DateOfBirth')" @keyup="[saveParticipantData(), validate('DateOfBirth', true)]" @change="[saveParticipantData(), validate('DateOfBirth', true)]" />
				</div>

				<div class="flex -ml-2 mt-6" v-else>

					<label class="px-2 flex flex-col w-full md:w-1/2">
							<div class="pb-2 font-bold">Fornavn</div>
							<div>{{ mobilePayData.ParticipantName }}</div>
					</label>

					<label class="px-2 flex flex-col w-full md:w-1/2">
							<div class="pb-2 font-bold">Fødselsdato</div>
							<div>{{ mobilePayData.DateOfBirthMasked }}</div>
					</label>
				</div>

				<label class="inline-flex items-center font-normal mt-6">
						<input type="checkbox" class="form-checkbox text-top focus:outline-none w-6 h-6" v-model="mobilePayData.Accepted" @change="[saveParticipantData()]">
						<span class="ml-2">
								Jeg bekræfter at ovenstående er mine personlige oplysninger.
						</span>
				</label>
			</div>

			<div class="mt-6 text-xs text-gray-900">
					For at kunne gennemføre betalingen, skal et af følgende kort være tilknyttet din MobilePay konto:<br/>
					<card-logos :card-logos="cardLogos"/>
			</div>
		</checkout-block-body>
	</checkout-block>
</template>

<script>
import debounce from "lodash/debounce";
import ParticipantField from "./ParticipantField";
import CardLogos from "./CardLogos";

export default {
		props: {
			mobilePayData: Object,
			associationGuid: String,
			cardLogos: Object
		},
    data: function() {
        return {
					missingFields: [],
					loading: false,
					confirmTried: false,
        }
    },
    components: {
				ParticipantField,
				CardLogos
		},
		computed: {
			showValidationMessage: function() {
				return !this.validateMobile() && this.mobilePayData && this.mobilePayData.Mobile && this.mobilePayData.Mobile.length > 0 && this.confirmTried;
			}
		},
    methods: {
			changeMobile: function() {
				if (this.mobilePayData.Accepted) {
					this.mobilePayData.Accepted = false;
					this.$store.commit("updateMobileData", this.mobilePayData);
					this.saveParticipantData();
				}
			},
		saveParticipantData: function () {
			this.$store.dispatch("saveBasket", this.$store.getters.basket);
		},
		isMissing: function(fieldName) {
			return this.missingFields.indexOf(fieldName) > -1;
		},
		validate: function(property, ifInvalid) {
			if (!ifInvalid || this.isMissing(property))
			{
				this.missingFields = this.missingFields.filter(f => f != property);
				var valid = this.mobilePayData[property] && this.mobilePayData[property] != "";

				if (!valid) {
					this.missingFields.push(property);
				}
			}
		},
		validateMobile: function() {
			if (!this.mobilePayData || !this.mobilePayData.Mobile)
			{
				return false;
			}

			this.mobilePayData.Mobile = this.mobilePayData.Mobile.replace(/[^0-9]/,"");
			return this.mobilePayData.Mobile.length == 8;
		},
		validateMobilePay: function() {
			this.confirmTried = true;
			if (this.validateMobile())
			{
				this.loading = true;
				this.$store.dispatch("confirmMobilePayNumber", { mobile : this.mobilePayData.Mobile, associationId: this.associationGuid }).then(() => {
					this.loading = false;
				});
			}
		}
	}
}
</script>
